"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _getLang = _interopRequireDefault(require("I18n/utils/getLang"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _sizes = require("HubStyleTokens/sizes");

var _Style = require("UIComponents/core/Style");

var _NameTypes = _interopRequireDefault(require("../constants/NameTypes"));

var _SingleNameInput = _interopRequireDefault(require("../internal/components/SingleNameInput"));

var _NAME_LABELS;

var FORMATS = {
  default: [_NameTypes.default.GIVEN_NAME, _NameTypes.default.FAMILY_NAME],
  ja: [_NameTypes.default.FAMILY_NAME, _NameTypes.default.GIVEN_NAME]
};
var NAME_LABELS = (_NAME_LABELS = {}, (0, _defineProperty2.default)(_NAME_LABELS, _NameTypes.default.GIVEN_NAME, function () {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "i18nAddon.fullNameInput.givenName"
  });
}), (0, _defineProperty2.default)(_NAME_LABELS, _NameTypes.default.FAMILY_NAME, function () {
  return _react.default.createElement(_FormattedMessage.default, {
    message: "i18nAddon.fullNameInput.familyName"
  });
}), _NAME_LABELS);
var nameMargin = parseInt(_sizes.DISTANCE_MEASUREMENT_EXTRA_SMALL, 10) / 2;

var _default = (0, _createReactClass.default)({
  displayName: "FullNameInput",
  propTypes: {
    direction: _propTypes.default.oneOf(['row', 'column']),
    familyNameInput: CustomRenderer.propType.isRequired,
    givenNameInput: CustomRenderer.propType.isRequired,
    wrap: _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      direction: 'column',
      wrap: 'nowrap'
    };
  },
  render: function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        familyNameInput = _this$props.familyNameInput,
        firstInputProps = _this$props.firstInputProps,
        givenNameInput = _this$props.givenNameInput,
        secondInputProps = _this$props.secondInputProps,
        wrap = _this$props.wrap;
    var lang = (0, _getLang.default)();
    var format = FORMATS[lang] ? FORMATS[lang] : FORMATS.default;
    var firstInputType = format[0];
    var secondInputType = format[1];
    var firstLabel = NAME_LABELS[firstInputType];
    var secondLabel = NAME_LABELS[secondInputType];
    var isRow = direction === 'row';
    var wrapBoxStyle = isRow ? {
      margin: (0, _Style.remCalc)(nameMargin)
    } : null;
    var flexBoxStyle = isRow ? {
      margin: (0, _Style.remCalc)(nameMargin * -1)
    } : null;
    var containerStyle = isRow ? {
      marginRight: (0, _Style.remCalc)(nameMargin * -2)
    } : null;
    var firstInput = givenNameInput;
    var secondInput = familyNameInput;

    if (firstInputType === _NameTypes.default.FAMILY_NAME) {
      firstInput = familyNameInput;
      secondInput = givenNameInput;
    }

    return _react.default.createElement("div", {
      style: containerStyle
    }, _react.default.createElement(_UIFlex.default, {
      direction: direction,
      wrap: wrap,
      align: "stretch",
      style: flexBoxStyle
    }, _react.default.createElement(_UIBox.default, {
      grow: 1,
      style: wrapBoxStyle
    }, _react.default.createElement(_SingleNameInput.default, Object.assign({}, firstInputProps, {
      input: firstInput,
      label: firstLabel
    }))), _react.default.createElement(_UIBox.default, {
      grow: 1,
      style: wrapBoxStyle
    }, _react.default.createElement(_SingleNameInput.default, Object.assign({}, secondInputProps, {
      input: secondInput,
      label: secondLabel
    })))));
  }
});

exports.default = _default;
module.exports = exports.default;